import PropTypes from 'prop-types';

import { ReactComponent as MinusIcon } from './../../../../assets/svg/minus.svg';
import { ReactComponent as PlusIcon } from './../../../../assets/svg/plus.svg';
import { ReactComponent as TrashIcon } from './../../../../assets/svg/trash.svg';
import styles from './Plum.module.css';
import Loader from '../../Loader/Loader';

const Plum = ({ children, onMinus, onPlus, trash, disabled = false }) => (
  <div className={`${styles.PlumContainer}`}>
    <button className={styles.IconWrapper} onClick={onPlus} disabled={disabled}>
      <PlusIcon />
    </button>
    {disabled ? <Loader /> : <div className={styles.PlumValue}>{children}</div>}
    <button className={styles.IconWrapper} onClick={onMinus} disabled={disabled}>
      {trash ? <TrashIcon /> : null}
      {!trash ? <MinusIcon /> : null}
    </button>
  </div>
);

Plum.propTypes = {
  children: PropTypes.node,
  onMinus: PropTypes.func,
  onPlus: PropTypes.func,
  trash: PropTypes.bool,
  disabled: PropTypes.bool
};

export default Plum;
